// extracted by mini-css-extract-plugin
export default {"overlayContainer":"overlay-container__overlay-container__JY9zF","overlayImage":"overlay-container__overlay-image__PONj7","spinner":"overlay-container__spinner__Dl0tW"};